import { styled } from '@mui/material/styles';

import { BaseMessage } from 'applications/GSP/pages/ParentHelper/components/Chat/components/Body/components/BaseMessage';

export const Wrapper = styled(BaseMessage)(({ theme }) => ({
  width: 'fit-content',
  flexDirection: 'row',

  '&:hover': {
    p: { backgroundColor: theme.palette.greys.main },
    '[role=group]': {
      display: 'block',
    },
  },
}));
